import React from 'react';
import styled from 'styled-components';
import { gutter } from '../../styles/mixins';
import { m28 } from '../../styles/typography';

const Host = styled.div``;

const Title = styled.div`
  ${m28};

  margin-bottom: ${gutter(5)};
  text-align: center;
`;

const Inputs = styled.div`
  margin-bottom: ${gutter(2)};
  > * {
    margin-bottom: ${gutter(3)};
  }

  > *:last-child {
    margin-bottom: 0;
  }
`;

const Pass = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;

  margin-bottom: ${gutter(6)};
`;

const Action = styled.div`
  margin-bottom: ${gutter(2)};
`;

const Signup = styled.div`
  text-align: center;
`;

interface LoginWrapProps {
  title: string;
  children: React.ReactNode;
  forgotPass: React.ReactNode;
  action: React.ReactNode;
  signup: React.ReactNode;
}

export const LoginWrap = ({
  title,
  children,
  forgotPass,
  action,
  signup,
}: LoginWrapProps) => {
  return (
    <Host>
      <Title>{title}</Title>
      <Inputs>{children}</Inputs>
      <Pass>{forgotPass}</Pass>
      <Action>{action}</Action>
      <Signup>{signup}</Signup>
    </Host>
  );
};
